export default "__VITE_ASSET__40d7c173__"